var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 6.00077C9.43913 6.00077 8.42172 6.42219 7.67157 7.17234C6.92143 7.92248 6.5 8.9399 6.5 10.0008C6.5 11.0616 6.92143 12.079 7.67157 12.8292C8.42172 13.5793 9.43913 14.0008 10.5 14.0008C11.5609 14.0008 12.5783 13.5793 13.3284 12.8292C14.0786 12.079 14.5 11.0616 14.5 10.0008C14.5 8.9399 14.0786 7.92248 13.3284 7.17234C12.5783 6.42219 11.5609 6.00077 10.5 6.00077ZM4.5 10.0008C4.49988 9.05647 4.72264 8.12548 5.15017 7.28351C5.5777 6.44154 6.19792 5.71236 6.9604 5.15529C7.72287 4.59822 8.60606 4.22898 9.53815 4.0776C10.4702 3.92622 11.4249 3.99698 12.3245 4.28412C13.224 4.57126 14.0432 5.06667 14.7152 5.73006C15.3872 6.39346 15.8931 7.2061 16.1919 8.1019C16.4906 8.9977 16.5737 9.95136 16.4343 10.8853C16.295 11.8193 15.9372 12.7072 15.39 13.4768L20.207 18.2938C20.3892 18.4824 20.49 18.735 20.4877 18.9972C20.4854 19.2594 20.3802 19.5102 20.1948 19.6956C20.0094 19.881 19.7586 19.9862 19.4964 19.9884C19.2342 19.9907 18.9816 19.8899 18.793 19.7078L13.977 14.8918C13.0794 15.53 12.0233 15.9089 10.9247 15.9869C9.826 16.0648 8.72707 15.8389 7.7483 15.3337C6.76953 14.8286 5.94869 14.0638 5.37572 13.1231C4.80276 12.1824 4.49979 11.1022 4.5 10.0008Z",
    fill: "#B0BABF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchLogin);
export default __webpack_public_path__ + "static/media/searchLogin.4cb7c50c91576b6b941db0f2b3a7a6b4.svg";
export { ForwardRef as ReactComponent };